import Checkbox from 'components/checkbox/checkbox';

export default Checkbox;
